import type { ServerMessages } from '../de/server.js';

export const server: ServerMessages = {
  unauthenticated: 'Zaloguj się',
  forbidden: 'Brak uprawnień',
  notFound: 'Nie znaleziono',
  invalidInput: 'Nieprawidłowe dane',
  payloadTooLarge: 'Za dużo danych',
  rateLimited: 'Zbyt wiele zapytań, spróbuj ponownie później',
  badRequest: 'Nieprawidłowe zapytanie',
  internal: 'Wewnętrzny błąd serwera',
  csrf: 'Zapytanie odrzucone: brak nagłówka ochronnego',
  userNotFound: 'Nie znaleziono użytkownika',
  priceCatalogNotFound: 'Nie znaleziono katalogu cen',
  priceCatalogDefault: 'Katalog domyślny pozostaje – najpierw ustaw inny katalog jako domyślny',
  emailTaken: 'Ten adres e-mail jest już zarejestrowany',
  ownPasswordReset: 'Własne hasło ustaw przez „Zmień hasło”',
  rejectOnlyPending: 'Odrzucić można tylko niezatwierdzone rejestracje',
  ownAccount: 'Własnego konta nie można tutaj zmienić',
  lastAdmin: 'Musi pozostać co najmniej jeden aktywny administrator',
  registrationDisabled: 'Rejestracja jest wyłączona',
  invalidAccessCode: 'Nieprawidłowy kod dostępu',
  invalidCredentials: 'Nieprawidłowy e-mail lub hasło',
  accountPending: 'Twoje konto czeka jeszcze na zatwierdzenie przez administratora',
  wrongPassword: 'Dotychczasowe hasło jest nieprawidłowe',
  noFile: 'Nie przesłano pliku',
  glbOnly: 'Prześlij plik .glb',
  modelNotFound: 'Nie znaleziono modelu',
  modelFileMissing: 'Brak pliku modelu w magazynie',
  modelUnavailable: 'Model nie istnieje lub nie jest udostępniony',
  unknownModels: 'Projekt odwołuje się do nieznanych modeli',
  projectNotFound: 'Nie znaleziono projektu',
  projectCorrupt: 'Zapisany projekt jest uszkodzony',
  projectIdMismatch: 'ID projektu się nie zgadza',
  documentRejected: '{detail}',
  projectChanged: 'Projekt został w międzyczasie zmieniony',
  versionNotFound: 'Nie znaleziono wersji',
  versionCorrupt: 'Zapisana wersja jest uszkodzona',
  saveBeforeReport: 'Najpierw zapisz – raport jest tworzony z zapisanego stanu',
  invalidReportImage: 'Widok „{title}” nie jest prawidłowym obrazem',
  invalidThumbnail: 'Obraz podglądu jest nieprawidłowy',
  glbTooSmall: 'Plik jest za mały na model GLB',
  glbNoMagic: 'To nie jest prawidłowy plik GLB (brak identyfikatora)',
  glbVersion: 'Obsługiwany jest tylko glTF 2.0',
  glbTruncated: 'Plik GLB jest niekompletny lub uszkodzony',
  glbNoJson: 'Plik GLB nie zawiera prawidłowego bloku JSON',
  glbBadJson: 'Plik GLB zawiera nieprawidłowy JSON',
  glbExternal:
    'Zewnętrzne odwołania do plików nie są obsługiwane – wyeksportuj samodzielny plik GLB',
  glbUnreadable: 'Nie udało się odczytać modelu: {detail}',
  glbNoScene: 'Model nie zawiera sceny',
  glbNoGeometry: 'Model nie zawiera widocznej geometrii',
  imageFormat: 'Prześlij obraz w formacie JPG lub PNG albo rysunek PDF',
  imageSize: 'Rozmiar obrazu jest nieprawidłowy',
  imageTooLarge: 'Obraz jest za duży (maksymalnie {max} pikseli na bok)',
  videoFormat: 'Prześlij wideo w formacie MP4 lub WebM',
  videoTooLarge: 'Wideo jest za duże (maksymalnie {max})',
  videoTooLong: 'Wideo jest za długie (maksymalnie 15 minut)',
  videoQuota: 'Miejsce na wideo jest pełne (zajęte {used} z {quota}). Usuń starsze nagrania.',
  videoNotFound: 'Nie znaleziono wideo',
  rangeInvalid: 'Nieprawidłowy zakres',
  readOnlyProject: 'Ten projekt jest udostępniony tylko do podglądu',
  ownerOnly: 'Może to zrobić tylko właściciel projektu',
  memberUnknown: 'Pod tym adresem e-mail nie jest zarejestrowany żaden użytkownik',
  memberIsOwner: 'Właściciel i tak ma pełny dostęp',
  memberNotFound: 'Ta osoba nie ma dostępu do projektu',
  chatMessageNotFound: 'Nie znaleziono wiadomości',
  chatFileNotFound: 'Nie znaleziono pliku',
  chatNotYours: 'Można usuwać tylko własne wiadomości',
  interpreterUnavailable: 'Dla tych języków nie skonfigurowano tłumacza',
  interpreterFailed: 'Usługa tłumacza jest obecnie niedostępna',
  dictationUnavailable: 'Dyktowanie nie jest skonfigurowane na tym serwerze',
  dictationFailed: 'Rozpoznawanie mowy jest obecnie niedostępne, spróbuj ponownie',
};
